module.exports = __webpack_public_path__ + "media/bootstrap-icons/skype-9445091d.svg";